module.exports = __webpack_public_path__ + "static/media/CSS-Portfolio.e6faea25.png";